import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs/Subject';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Injectable()
export class IndexService {
    menu: string;   // 当前选定菜单
    isShowNav: Boolean = false;  // 是否显示头部和菜单
    miniNav = false;
    loading$ = new Subject<boolean>();

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService,
        private titleService: Title
    ) {
        this.router.events
            .filter((event) => event instanceof NavigationStart)
            .subscribe(x => {
                this.loading$.next(true);
            });

        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .subscribe(x => {
                this.loading$.next(false);
            });

        // 设置title
        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .map(() => this.activatedRoute)
            .map((route) => {
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .filter((route) => route.outlet === 'primary')
            .mergeMap((route) => route.data)
            .subscribe((event: any) => {
                const title = this.translate.instant(event['title'] || '');
                this.titleService.setTitle(`SRM 2.0 - ${title}`);
                this.menu = event.menu;
            });

        // 根据路由设置是否显示头部和菜单
        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .subscribe((url: NavigationEnd) => {
                this.isShowNav = !_.some([ // 不需要显示菜单的路由数组
                    '',
                    '/login',
                    '/register',
                    '/index',
                    '/findPsd',
                    '/wechat-check',
                    '/price/enquiry-public',
                    '/price/enquiry-public-detail'
                ], x => {
                    if (x === url.urlAfterRedirects) return true;
                    if (x.length && _.startsWith(url.urlAfterRedirects, x)) return true;
                    return false;
                });
            });
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/services/index.service.ts